import React, { useContext } from 'react';
import {
  Field,
  SitecoreContext,
  withSitecoreContext,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';

import './index.scss';
import { APIWebstoreContext } from '../../context/globalContext';
import {
  DIGITAL_DELIVERY,
  DIGITAL_PRINT_DELIVERY,
  NO_DIGITAL_DELIVERY,
  PRINT_DELIVERY,
  STANDARDS_DIGITAL_DELIVERY,
} from '../../utils/constants';

export interface IDigitalDelivery {
  IsDigitalDelivery: boolean;
}

export const DigitalDeliveryDetails: IDigitalDelivery = {
  IsDigitalDelivery: true,
};

export type DigitalDeliveryProps = WithSitecoreContextProps & {
  fields: {
    DigitalDeliveryDesc: Field<string>;
    DigitalDeliveryTitle: Field<string>;
    PrintDeliveryDesc: Field<string>;
    PrintDeliveryTitle: Field<string>;
    DigitalAndPrintDeliveryDesc: Field<string>;
    DigitalAndPrintDeliveryTitle: Field<string>;
  };
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

const DigitalDelivery = ({ fields, sitecoreContext }: DigitalDeliveryProps): React.JSX.Element => {
  const { state } = useContext(APIWebstoreContext);

  function RenderDeliverySection(deliveryHeader: string) {
    const shouldPrefixStandards = deliveryHeader.startsWith(`${STANDARDS_DIGITAL_DELIVERY}`);

    if (
      deliveryHeader === DIGITAL_DELIVERY ||
      deliveryHeader === `${STANDARDS_DIGITAL_DELIVERY} ${DIGITAL_DELIVERY}`
    ) {
      return (
        <div className="checkoutDigitalDeliverySection">
          <div className="reviewOrderSection">
            <div className="reviewOrderSNo">1</div>
            <div className="reviewOrderTitle">
              <p>
                {shouldPrefixStandards ? `${STANDARDS_DIGITAL_DELIVERY} ` : ''}
                {fields?.DigitalDeliveryTitle?.value}
              </p>
            </div>
          </div>
          <div className="digitalDeliveryArea">
            <p>{fields?.DigitalDeliveryDesc?.value}</p>
          </div>
        </div>
      );
    } else if (
      deliveryHeader === PRINT_DELIVERY ||
      deliveryHeader === `${STANDARDS_DIGITAL_DELIVERY} ${PRINT_DELIVERY}`
    ) {
      return (
        <div className="checkoutPrintDeliverySection">
          <div className="reviewOrderSection">
            <div className="reviewOrderSNo">1</div>
            <div className="reviewOrderTitle">
              <p>
                {shouldPrefixStandards ? `${STANDARDS_DIGITAL_DELIVERY} ` : ''}
                {fields?.PrintDeliveryTitle?.value}
              </p>
            </div>
          </div>
          <div className="digitalDeliveryArea">
            <p>{fields?.PrintDeliveryDesc?.value}</p>
          </div>
        </div>
      );
    } else if (
      deliveryHeader === DIGITAL_PRINT_DELIVERY ||
      deliveryHeader === `${STANDARDS_DIGITAL_DELIVERY} ${DIGITAL_PRINT_DELIVERY}`
    ) {
      return (
        <div className="checkoutDigitalAndPrintDeliverySection">
          <div className="reviewOrderSection">
            <div className="reviewOrderSNo">1</div>
            <div className="reviewOrderTitle">
              <p>
                {shouldPrefixStandards ? `${STANDARDS_DIGITAL_DELIVERY} ` : ''}
                {fields?.DigitalAndPrintDeliveryTitle?.value}
              </p>
            </div>
          </div>
          <div className="digitalDeliveryArea">
            <p>{fields?.DigitalAndPrintDeliveryDesc?.value}</p>
          </div>
        </div>
      );
    } else if (deliveryHeader === NO_DIGITAL_DELIVERY) {
      return <></>;
    } else {
      return (
        <div className="checkoutDigitalDeliverySection">
          <div className="reviewOrderSection">
            <div className="reviewOrderSNo">1</div>
            <div className="reviewOrderTitle">
              <p>Waiting for Delivery Title</p>
            </div>
          </div>
          <div className="digitalDeliveryArea">
            <p>Loading Digital delivery area...</p>
          </div>
        </div>
      );
    }
  }
  return (
    <div className="digitaldelivery">
      {sitecoreContext.pageEditing && (
        <>
          <p>DigitalDelivery Component Edit Mode</p>
        </>
      )}
      <h1 className="checkoutPageTitle">Checkout</h1>
      <div>{RenderDeliverySection(state?.deliveryStatus || '')}</div>
    </div>
  );
};

export default withSitecoreContext()(DigitalDelivery);
